import { useState, useEffect, useRef } from 'react';

//styles
import { Wrapper } from './styles';

const Checkbox = ({ name, size = 20, width, value = false, isDisabled, onChange, classes }) => {
  return (
    <Wrapper
      checked={value}
      size={size}
      width={width}
      className={classes}>
      <input
        name={name}
        disabled={isDisabled}
        type='checkbox'
        checked={value}
        onChange={(e) => {
          if (onChange) onChange(!value);
        }}
        onClick={(e) => {
          e.stopPropagation();
        }}
      />
      <span
        className='checkmark'
        onClick={(e) => e.stopPropagation()}></span>
    </Wrapper>
  );
};

export default Checkbox;
